export const industries = [
'Acupressure (Elementary Shiatsu)',
'Aerobics',
'Alexander Technique',
'Any Hairdressing Treatment',
'Aromatherapy - Initial Training And Advanced',
'Attachment of Hair Extensions',
'Attachment of tooth jewellery using adhesive only',
'Aura-Soma Treatments',
'Body - Body Wrap Treatments',
'Body - Colour Analysis',
'Body - Cosmetic Camouflage',
'Body - Depilation By Blend Method',
'Body - Depilation By Electrical Diathermy',
'Body - Depilation By Tweezer Method',
'Body - Manicure',
'Body - Massage Electro-Mechanical',
'Body - Massage Manual',
'Body - Nail Building/Application/Sculpturing',
'Body - Pedicure',
'Body - Sugaring',
'Body - Waxing Hot/Cold/Warm',
'Colour Therapy',
'Crystal Gem Therapy',
'Dance/Drama Therapy',
'Dietary/Nutritional Advice',
'Ear Piercing - Gun And Stud',
'Electro-Mechanical Slimming Treatments',
'Facial - Ear Piercing',
'Facial - Eyebrow Shaping',
'Facial - Eyebrow/Eyelash Tinting',
'Facial - eyelash extensions/weaving',
'Facial - Facial Masks',
'Facial - Facial Sauna',
'Facial - Faradic Toning',
'Facial - Make-up Make Over',
'Facial - Massage Manual',
'Facial - threading',
'Facial Masks And/or Facial Massages',
'Hair Removal - By Electrolysis',
'Hair Removal - Other Than By Electrolysis',
'Magnetic Therapy',
'Make-up Make Over',
'Massage',
'Massage - Indian Head',
'Massage - Initial Training And Advanced',
'Music Therapy',
'Perms',
'Physical Exercising With Individuals And Groups',
'Reflexology - Basic And Advanced',
'Reiki',
'Shiatsu Advanced',
'Spray/airbrush tanning',
'Tinting And Bleaching',
];

export default industries; 